module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-white-fa98b24be641231e5ed4ce9ca8458865.svg";